// extracted by mini-css-extract-plugin
export default {"placeholder":"InteractiveImportRowCellPlaceholder-placeholder-WVc4a","optional":"InteractiveImportRowCellPlaceholder-optional-xZuLy"};